import React, { Component } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import slide from './home_assets/card_img.svg';
import Slider from "react-slick";

import './home_styles/homeslider.css';

export default function HomeSlider() {

  const settings = {
    className: "center",
    dots: true,
    infinite: true,
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          centerMode: true,
          centerPadding: "60px",
          autoplaySpeed: 2000,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: "60px",
          autoplay: true,
          autoplaySpeed: 2000,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          centerMode: true,
          centerPadding: "60px",
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
          <div>
        {/* <h2>Center Mode</h2> */}
        <Slider {...settings}>
          <div>
            <img src={slide} alt="Slider" className='img-fluid' />
          </div>
          <div>
          <img src={slide} alt="Slider" className='img-fluid' />
          </div>
          <div>
          <img src={slide} alt="Slider" className='img-fluid' />
          </div>
          <div>
          <img src={slide} alt="Slider" className='img-fluid' />
          </div>
          <div>
          <img src={slide} alt="Slider" className='img-fluid' />
          </div>
          <div>
          <img src={slide} alt="Slider" className='img-fluid' />
          </div>
        </Slider>
      </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
